// Restaurants Scroller — AJAX category filter with pushState URL state.
// Imported from js/global.js. No-op when the block isn't on the page.

const STATE_KEY = "restaurantsScroller";

export default function initRestaurantsScroller() {
  const block = document.querySelector(".aviatrix-block--restaurants-scroller");
  if (!block || typeof restaurantsScroller === "undefined") return;

  const scroller = block.querySelector(".restaurants-scroller__scroller");
  const track = block.querySelector(".restaurants-scroller__cards");
  const filterBtns = block.querySelectorAll(".restaurants-scroller__filter");
  if (!scroller || !track) return;

  let isLoading = false;
  let currentCategory = readActiveCategory();

  function readActiveCategory() {
    const active = block.querySelector(".restaurants-scroller__filter.is-active");
    return active ? active.getAttribute("data-category") || "" : "";
  }

  function setFilterActive(category) {
    filterBtns.forEach((btn) => {
      const isActive = (btn.getAttribute("data-category") || "") === category;
      btn.classList.toggle("is-active", isActive);
      btn.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  }

  function updateUrl(category) {
    const params = new URLSearchParams(window.location.search);
    if (category) {
      params.set("restaurants_cat", category);
    } else {
      params.delete("restaurants_cat");
    }
    const qs = params.toString();
    const newUrl =
      window.location.pathname +
      (qs ? "?" + qs : "") +
      window.location.hash;
    window.history.pushState({ key: STATE_KEY, category }, "", newUrl);
  }

  async function fetchResults(category, options = {}) {
    if (isLoading) return;
    isLoading = true;
    scroller.setAttribute("aria-busy", "true");

    try {
      const body = new URLSearchParams({
        action: "restaurants_filter",
        nonce: restaurantsScroller.nonce,
        category: category || "",
      });

      const response = await fetch(restaurantsScroller.ajaxurl, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body,
      });
      const data = await response.json();

      if (data && data.success) {
        track.innerHTML = data.data.html;
        currentCategory = category;
        setFilterActive(category);

        // Reset scroll position so the new set starts at card 1.
        track.scrollLeft = 0;

        // Let the shared scroller progress bar recalc thumb width / position.
        scroller.dispatchEvent(new CustomEvent("scroller:refresh", { bubbles: true }));

        if (options.pushUrl !== false) {
          updateUrl(category);
        }
      } else {
        track.innerHTML =
          '<li class="restaurants-scroller__no-results">Something went wrong loading restaurants. Please try again.</li>';
      }
    } catch (err) {
      console.error("Restaurants Scroller fetch failed:", err);
      track.innerHTML =
        '<li class="restaurants-scroller__no-results">Something went wrong loading restaurants. Please try again.</li>';
    } finally {
      scroller.setAttribute("aria-busy", "false");
      isLoading = false;
    }
  }

  filterBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      const cat = btn.getAttribute("data-category") || "";
      if (cat === currentCategory) return;
      fetchResults(cat);
    });
  });

  window.addEventListener("popstate", (e) => {
    const state = e.state && e.state.key === STATE_KEY ? e.state : null;
    let category = "";
    if (state) {
      category = state.category || "";
    } else {
      const params = new URLSearchParams(window.location.search);
      category = params.get("restaurants_cat") || "";
    }
    fetchResults(category, { pushUrl: false });
  });
}
